import { ILogger } from '@cian/logger';
import { IRegistry } from '@cian/mf-registry/browser';
import { IServicePickerWidgetMicrofrontendAPI } from '../../../../shared/types/microfrontends/servicePickerWidget';

interface IParams {
  logger: ILogger;
  microfrontendsRegistry: IRegistry;
}

export const getServicePickerWidgetMicrofrontendAPI = (params: IParams): IServicePickerWidgetMicrofrontendAPI => {
  const { logger, microfrontendsRegistry } = params;

  const servicePickerWidgetApiCall = async <Return = void, Params = unknown>(
    path: string,
    params?: Params,
  ): Promise<Return | undefined> => {
    try {
      const api = await microfrontendsRegistry.microfrontendStrict('service-picker-widget-frontend').api()!.ensure();

      return api.call(path, params);
    } catch (error) {
      logger.error(error, {
        domain: 'microfrontends.service-picker-widget.api-call',
        details: { path, params: JSON.stringify(params) },
      });

      return;
    }
  };

  return {
    setOffer: async parameters => {
      return servicePickerWidgetApiCall('/v1/set-offer', parameters);
    },

    setUser: async parameters => {
      return servicePickerWidgetApiCall('/v1/set-user', parameters);
    },

    loadPublishTerms: async () => {
      return servicePickerWidgetApiCall('/v1/reload-publish-terms');
    },

    getState: async () => {
      return servicePickerWidgetApiCall('/v1/get-state');
    },

    getServices: async () => {
      return servicePickerWidgetApiCall('/v1/get-services');
    },

    switchToSelfMoneySource: () => {
      return servicePickerWidgetApiCall('/v1/switch-to-self-money-source');
    },

    checkPublishAvailability: async () => {
      const result = await servicePickerWidgetApiCall('/v1/check-publish-availability');

      return !!result;
    },
  };
};
